import settings from 'settings'
import { getRequest, postRequest } from 'features/common'
import { BuilderGenAIAction, BuilderGenAIActionResult, BuilderGenAIEnvironment, MapConfigForAgent } from '../types'

const { workspaceApiUrl } = settings

export interface CreateAgent {
  mapId: string
  mapConfig: MapConfigForAgent
  userContext: string
  environment: BuilderGenAIEnvironment
}
export async function createAgent({
  mapId,
  mapConfig,
  userContext,
  environment
}: CreateAgent): Promise<{ agent: string; createdAt: string }> {
  const url = `${workspaceApiUrl}/genai/${mapId}/${environment}`
  return await postRequest(url, { mapConfig, userContext })
}

export async function createThread({
  mapId,
  environment
}: {
  mapId: string
  environment: BuilderGenAIEnvironment
}): Promise<{ parent: string }> {
  const url = `${workspaceApiUrl}/genai/${mapId}/newThread/${environment}`
  return await getRequest(url)
}

export type GenAIResponse = {
  message?: string
  actions?: BuilderGenAIAction[]
}

export async function sendMessage({
  mapId,
  parent,
  message,
  environment
}: {
  mapId: string
  parent: string
  message: string
  environment: BuilderGenAIEnvironment
}): Promise<GenAIResponse> {
  const url = `${workspaceApiUrl}/genai/${mapId}/conversation/${environment}`
  const response = await postRequest(url, { message, parent })
  return response
}

export async function sendActionsResult({
  mapId,
  actions,
  environment
}: {
  mapId: string
  actions: BuilderGenAIActionResult[]
  environment: BuilderGenAIEnvironment
}): Promise<GenAIResponse> {
  const url = `${workspaceApiUrl}/genai/${mapId}/action/${environment}`
  const response = await postRequest(url, { actions })
  return response
}
